import { useEffect, useState } from 'react'

import { EMPTY_LIST, EMPTY_OBJECT } from '../../../../constants/common'
import { useAsyncCallback } from '../../../../hooks'
import { getUploadingFilesAll } from '../../DocFlowUploading'
import { useDocFlowContext } from '../useDocFlowContext'

export function useGetUploadingFiles({
  canLoad = true,
  params,
} = EMPTY_OBJECT) {
  const { documentId } = useDocFlowContext()

  const [isInitiated, setInitiated] = useState(false)
  const [uploadingFiles, setUploadingFiles] = useState(EMPTY_LIST)

  const handleLoadUploadingFilesAll = useAsyncCallback(
    (id, requestParams) => {
      return getUploadingFilesAll(
        id || documentId,
        requestParams || params
      ).then(({ data }) => {
        setUploadingFiles(data.items)

        return data
      })
    },
    [documentId, params]
  )

  const handleInitUploadingFilesAll = useAsyncCallback(
    (id, requestParams) => {
      setInitiated(false)

      return handleLoadUploadingFilesAll(id, requestParams).then(data => {
        setInitiated(true)

        return data
      })
    },
    [handleLoadUploadingFilesAll]
  )

  const handleReloadUploadingFilesAll = useAsyncCallback(
    handleLoadUploadingFilesAll,
    [handleLoadUploadingFilesAll]
  )

  useEffect(() => {
    if (canLoad) {
      handleInitUploadingFilesAll(documentId, params)
    }
  }, [canLoad])

  return {
    handleInitUploadingFilesAll,
    handleReloadUploadingFilesAll,
    isInitiated,
    uploadingFiles,
  }
}
